import { MARGIN_TYPES, ValidateYup } from "@tastyworks/tastyworks-api"
import { mixed, object } from "yup"

export const MARGIN_TYPES_VALUES = Object.freeze(Object.values(MARGIN_TYPES))

export const tradingMethodSchema = ValidateYup.buildSchema(
  "TradingMethod",
  object({
    tradingMethod: mixed<MARGIN_TYPES>()
      .oneOf(Object.values(MARGIN_TYPES))
      .required(),
  })
)

if (import.meta.vitest) {
  const { it, expect, describe } = import.meta.vitest

  describe("tradingMethodSchema", () => {
    it("validates correctly", async () => {
      const input = {
        tradingMethod: MARGIN_TYPES.CASH,
      }

      const result = await tradingMethodSchema.validate(input)

      expect(result).toEqual(input)
    })

    it("throws when tradingMethod isn't provided", async () => {
      await expect(() => tradingMethodSchema.validate({})).rejects.toThrow()
    })

    it("throws when tradingMethod isn't an accepted type", async () => {
      const input = {
        tradingMethod: "ABC",
      }

      await expect(() => tradingMethodSchema.validate(input)).rejects.toThrow()
    })
  })
}
